import { HeatMap2D, HeatmapParams } from 'types/heatmap'
import { axiosInstance } from './api'

export const statsApi = {
  getHeatMap(params: HeatmapParams) {
    return axiosInstance.post<HeatMap2D>(`heatmap`, params)
  },
}
